// MOD-17 / K-2 / R-1 — runtime component render'ının GÜVENLİK ÇEKİRDEĞİ.
//
// İki savunma katmanı, ikisi de burada tek noktada:
//   1) `{{propKey}}` placeholder'ları HTML-escape'li prop değerleriyle doldurulur
//      (bir prop değeri asla markup olarak yürütülemez — attribute context dahil,
//      tırnak/açı işaretleri entity'ye çevrilir).
//   2) Elde edilen HTML `sanitizeHtml` (DOMPurify allow-list) ile temizlenir.
// templateHtml BE'de kayıt anında ayrıca sanitize edilir; bu render-zamanı katmanı
// derinlemesine savunmadır (prop değerleri sayfa verisinden runtime gelir).
//
// Hem Studio canlı önizlemesi hem Puck runtime bloğu render'ı bu modülü kullanır.

import { sanitizeHtml } from '@shared/utils/sanitize';

/**
 * Template `{{ key }}` placeholder'ı — BE `ComponentTemplate.PlaceholderRegex` ile
 * BİREBİR aynı: opsiyonel boşluk, key = harf/alt-çizgiyle başlar, harf/rakam/alt-çizgi.
 * Global bayrak: her eşleşmeyi değiştirmek için (replace) yeniden kullanılır.
 */
export const PLACEHOLDER_REGEX = /\{\{\s*([A-Za-z_][A-Za-z0-9_]*)\s*\}\}/g;

/** templateHtml'in atıf yaptığı benzersiz placeholder anahtarları. */
export function extractPlaceholders(templateHtml: string | null | undefined): string[] {
  if (!templateHtml) return [];
  const keys = new Set<string>();
  for (const m of templateHtml.matchAll(PLACEHOLDER_REGEX)) {
    if (m[1]) keys.add(m[1]);
  }
  return [...keys];
}

/**
 * HTML özel karakterlerini entity'ye çevirir. Beş karakter de kaçırılır ki değer
 * hem element-içeriği hem attribute (tek/çift tırnaklı) bağlamında güvenli olsun.
 */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * templateHtml içindeki her `{{key}}` yerini, `values[key]`'in HTML-escape'li
 * string karşılığıyla doldurur; şemada olmayan/eksik değer → boş string (tolerant
 * render, K-9). Değiştirme TEK geçişte yapılır → escape edilmiş bir değer yeni bir
 * placeholder üretemez (re-enjeksiyon yok). Sonuç sanitize edilerek döner.
 */
export function interpolateTemplate(
  templateHtml: string | null | undefined,
  values: Record<string, unknown>,
): string {
  if (!templateHtml) return '';
  const filled = templateHtml.replace(PLACEHOLDER_REGEX, (_match, key: string) => {
    const raw = values[key];
    // Yalnız şema primitifleri (string/number/boolean) basılır; nesne/dizi/diğer
    // değerler görsel gürültü ('[object Object]') yerine boş bırakılır.
    if (typeof raw === 'string') return escapeHtml(raw);
    if (typeof raw === 'number' || typeof raw === 'boolean') return escapeHtml(String(raw));
    return '';
  });
  return sanitizeHtml(filled);
}
